import { AgmMap } from '@agm/core';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { WidgetBaseComponent } from '~/app/open-age/insight/components/widget.base.component';
import { UxService } from '../../../../core/services/ux.service';
import { ReportTypeService } from '../../../../open-age/insight/services/report-type.service';
import { WidgetDataService } from '../../../../open-age/insight/services/widget-data.service';

@Component({
  selector: 'insight-google-map-widget',
  templateUrl: './google-map-widget.component.html',
  styleUrls: ['./google-map-widget.component.css']
})
export class GoogleMapComponent extends WidgetBaseComponent {

  @Input()
  zoomInput = 5;

  @Output()
  zoom: EventEmitter<number> = new EventEmitter();

  mapItems = [];

  mapTypeControl: true;
  disableDefaultUI: true;

  currentPosition: any;

  lat: number;
  lng: number;

  @ViewChild(AgmMap) public agmMap: AgmMap;

  headArray = [];
  constructor(api: WidgetDataService, reportTypeService: ReportTypeService, uxService: UxService) {
    super(api, reportTypeService, uxService);
    // this.afterInitialization = () => {
    //   this.headArray = this.reportType.columns.map((c) => c.key);
    // };
    this.afterProcessing = () => {
      console.log(this.items.length);
      if (navigator) {
        navigator.geolocation.getCurrentPosition((pos) => {
          this.lng = pos.coords.longitude;
          this.lat = pos.coords.latitude;
        });
      }
      this.setMapData(this.items);
    };
  }

  setMapData(items) {
    this.mapItems = [];
    items.forEach((item) => {
      if ((item.label === 0) || (item.label === '*')) {
        item.label = '';
      }
      const newItem = {
        longitude: item.longitude,
        latitiude: item.latitude,
        icon: this.getIconURL(item.icon),
        label: item.label.toString(),
        companyName: item.company
      };
      this.mapItems.push(newItem);
    });
  }

  getIconURL(item) {
    let icon;
    switch (item) {
      case 'pointer':
        icon = {
          url: 'https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png',
          height: 43,
          width: 27
        };
        return icon;
        break;
      case 'collection':
        icon = {
          url: 'http://maps.google.com/mapfiles/kml/shapes/shaded_dot.png',
          height: 40,
          width: 40
        };
        return icon;
        break;
      default:
        icon = {
          url: 'https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png',
          height: 43,
          width: 27
        };
        return icon;
        break;
    }
  }

  zoomChangeNumber(value) {
    this.zoom.emit(value);
    console.log(value);
  }

}
